import Axios from "../../configs/axios.config";

export const createLeave = (data) => Axios.post(`/leave`, data).then(response => response.data.data);
export const updateLeave = (id, data) => Axios.put(`/leave/${id}`, data);
export const updateLeavePost = (data) => Axios.post(`/leave/approved`, data);
export const getLeaveList = (data) => Axios.get('/leave', { params: data }).then(response => response.data);
export const getLeaveDetail = (id) => Axios.get(`/leave/${id}`).then(response => response.data.data);
export const deleteLeave = (id) => Axios.delete(`/leave/${id}`);

 
// Leave Allocation

export const allocateLeave = (data) => Axios.post(`/leave-allocation`, data).then(response => response.data);
export const allocateBulkLeave = (data) => Axios.post(`/leave-department-allocation`, data).then(response => response.data);
export const allocateAnnualLeave = (data) => Axios.post(`/leave-annual-allocation`, data).then(response => response.data);

// Individual Leave Allocation History
export const getLeaveAllocationHistory = (data) => Axios.get('/leave-allocation', { params: data }).then(response => response.data);

// Bulk Leave Allocation History (Department-based)
export const getBulkLeaveAllocationHistory = (data) => Axios.get('/leave-department-allocation', { params: data }).then(response => response.data);

// Leave Summary
export const getLeaveSummary = (data) => Axios.get('/leave/summary', { params: data }).then(response => response.data);

export const updateApproval = (data, id) => Axios.put(`/leave-approval`, data).then(response => response.data.data);